/**
 * @brief   アラート設定のサブカテゴリ種別
 */
export enum SubCategoryMode {
    SubItem = 0,    // サブアイテム(デフォルト)
    OS,             // OS種別
    SubSubItem,     // サブサブカテゴリ
}